const longDateFormat = new Intl.DateTimeFormat('en-US', { month: 'long', day: '2-digit', year: 'numeric' });

/**
 * Formats a date as "MMMM DD, YYYY" (for example "January 05, 2026"), matching the moment.js output it replaces:
 * a missing value formats the current date and an unparsable value formats as "Invalid date".
 */
export function formatLongDate(value?: Date | string): string {
  // Date parses ISO date-only strings as UTC midnight; moment used the local calendar day.
  const dateOnly = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
  let date: Date;
  if (dateOnly) {
    date = new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
  } else {
    date = value === undefined ? new Date() : new Date(value);
  }
  return Number.isNaN(date.getTime()) ? 'Invalid date' : longDateFormat.format(date);
}
